export default {
	type: 'object',
	properties: {
		currentPage: { type: 'number' },
		section: { type: 'number' },
	},
	required: [],
	additionalProperties: false,
}
